"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyGutterBottom = exports.typographyWeight = exports.typographyColor = exports.typographyDisplay = void 0;

var _stylitas = require("@creditas/stylitas");

const typographyDisplay = ({
  display
}) => display && (0, _stylitas.css)`
    display: ${display};
  `;

exports.typographyDisplay = typographyDisplay;

const typographyColor = ({
  color,
  theme
}) => {
  if (!color) {
    return null;
  }

  switch (color) {
    case 'danger':
      return (0, _stylitas.css)`
        color: ${theme.bColordanger};
      `;

    case 'info':
      return (0, _stylitas.css)`
        color: ${theme.bColorinfo};
      `;

    case 'success':
      return (0, _stylitas.css)`
        color: ${theme.bColorsuccess};
      `;

    case 'warning':
      return (0, _stylitas.css)`
        color: ${theme.bColorwarning};
      `;

    default:
      return (0, _stylitas.css)`
        color: ${color};
      `;
  }
};

exports.typographyColor = typographyColor;

const typographyWeight = ({
  weight
}) => weight && (0, _stylitas.css)`
    font-weight: ${weight};
  `;

exports.typographyWeight = typographyWeight;

const typographyGutterBottom = ({
  gutterBottom
}) => gutterBottom && (0, _stylitas.css)`
    margin-bottom: 8px;
  `;

exports.typographyGutterBottom = typographyGutterBottom;